import { API_BASE_URL } from '../config';
import { apiFetch } from '../utils/apiFetch';

export interface KrBacktestRequest {
  symbols: string[];
  symbol_source?: 'manual' | 'kr_watchlist';
  start_date: string;
  end_date: string;
  initial_cash: string;
  strategy_profile: string;
  bar_limit: number;
  position_size_percent: number;
}

export interface KrBacktestSummary {
  run_id: string;
  market: 'KR';
  mode: string;
  status: string;
  symbols: string[];
  symbols_display?: KrSymbolDisplay[];
  strategy_profile: string;
  initial_cash: number;
  dataset_hash: string | null;
  config_hash: string;
  decision_hash: string | null;
  execution_hash: string | null;
  decisions: {
    total: number;
    by_action: Record<string, number>;
  };
  orders: { total: number };
  fills: { total: number };
  warnings: string[];
}

export interface KrSymbolDisplay {
  symbol: string;
  name: string | null;
}

export async function runKrBacktest(
  request: KrBacktestRequest
): Promise<KrBacktestSummary> {
  const response = await apiFetch(`${API_BASE_URL}/api/simulations/kr/backtests`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
  if (!response.ok) throw new Error(await errorMessage(response));
  return response.json();
}

export async function getKrBacktest(runId: string): Promise<KrBacktestSummary> {
  const response = await apiFetch(
    `${API_BASE_URL}/api/simulations/kr/backtests/${runId}`
  );
  if (!response.ok) throw new Error(await errorMessage(response));
  return response.json();
}

async function errorMessage(response: Response): Promise<string> {
  try {
    const data = await response.json();
    return data.detail || `KR 백테스트 API 오류: ${response.status}`;
  } catch {
    return `KR 백테스트 API 오류: ${response.status}`;
  }
}
